import { Badge } from "@atlant/ui"

import { StatusBadge } from "../../components/status-badge.tsx"
import type { InboxInvoice } from "../page.tsx"

export const InvoiceTypeBadge = ({
  invoice: { type, needsReview },
}: {
  invoice: Pick<InboxInvoice, "type" | "needsReview">
}) => (
  <div className="flex items-center gap-1">
    {type === "LATE" && <StatusBadge status="late" />}
    {type === "UNKNOWN" && (
      <Badge variant="outline" className="text-muted-foreground rounded-full font-medium">
        Unknown
      </Badge>
    )}
    {needsReview && <StatusBadge status="needsReview" />}
  </div>
)
